'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * TableHeaderCell component, used to display the header cells of a table. Renders a native HTML th element.
 *
 * @example
 * <TableHeaderCell>Name</TableHeaderCell>
 */
const TableHeaderCell = forwardRef(function TableHeaderCell({ sort, children, ...rest }, ref) {
    return (jsx("th", { "aria-sort": sort, ref: ref, ...rest, children: sort ? jsx("button", { type: 'button', children: children }) : children }));
});

export { TableHeaderCell };
